module.exports = __webpack_public_path__ + "static/khalil-headshot-fecbe8f1d39b9e2b0ae79cc0005e0efb.png";